/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} United_StatesInputs */

const en_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`United States`)
};

const es_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estados Unidos`)
};

const fr_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`États-Unis`)
};

const de_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinigte Staaten`)
};

const ja_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アメリカ合衆国`)
};

const zh_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美国`)
};

const ar_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الولايات المتحدة`)
};

const id_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amerika Serikat`)
};

const it_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stati Uniti`)
};

const ru_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`США`)
};

const pt_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estados Unidos`)
};

const ko_united_states = /** @type {(inputs: United_StatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미국`)
};

/**
* | output |
* | --- |
* | "United States" |
*
* @param {United_StatesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const united_states = /** @type {((inputs?: United_StatesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<United_StatesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_united_states(inputs)
	if (locale === "es") return es_united_states(inputs)
	if (locale === "fr") return fr_united_states(inputs)
	if (locale === "de") return de_united_states(inputs)
	if (locale === "ja") return ja_united_states(inputs)
	if (locale === "zh") return zh_united_states(inputs)
	if (locale === "ar") return ar_united_states(inputs)
	if (locale === "id") return id_united_states(inputs)
	if (locale === "it") return it_united_states(inputs)
	if (locale === "ru") return ru_united_states(inputs)
	if (locale === "pt") return pt_united_states(inputs)
	return ko_united_states(inputs)
});